import { Component, OnInit, Input } from '@angular/core';
import { ProductService } from '@app/services/Product/product.service';
import { ActivatedRoute } from '@angular/router';
import { FeedsService } from '@app/services/feeds/feeds.service';
import { FeedRating } from '@app/model/feedsRating';
import { environment } from '../../../../environments/environment.prod';

@Component({
  selector: 'app-similer-product',
  templateUrl: './similer-product.component.html',
  styleUrls: ['./similer-product.component.scss']
})
export class SimilerProductComponent implements OnInit {
  myProductList:any;
   serverImgUrl:any;
   userInfoId:any;
   sellProductInfoId:any;

   feedList:any;
   feedTotal:any;
   feedAvg:any;
   
  constructor(
    private route: ActivatedRoute,
    private productService: ProductService,
    private feedsService: FeedsService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.userInfoId = params['uid'];
      this.sellProductInfoId = params['id'];
    })
    if(this.userInfoId && this.sellProductInfoId){
      this.getProductDetailsByUUId();
      this.fetchFeedsByProductByUUId_Id();
    }
    
    this.serverImgUrl = environment.IMG_URL;
  } 
  
   // Get all products
   getProductDetailsByUUId(): void {
    this.productService.getSellerProductInfoByUUId(this.userInfoId).subscribe({
      next: (res:any) => {
        if (res.success !== 0) {
          this.myProductList = res.data; 
        } else {
          this.myProductList = "The brand selling item or products does not have a published."; 
        }
      }
    }
    );
  }

  fetchFeedsByProductByUUId_Id(): void {
    this.feedsService.fetchFeedsByProduct(this.userInfoId, this.sellProductInfoId)
      .subscribe({
        next: (p) => {
          this.feedList = p as FeedRating;
          this.feedTotal = this.feedList.data.length;
          var sum = 0;
          if (this.feedList.data != null && this.feedList.data.length > 0) {
            for (var i = 0; i < this.feedList.data.length; i++) {
              sum += this.feedList.data[i].feedRating;
            }
            this.feedAvg = sum / this.feedList.data.length;
          }
          else {
            this.feedAvg = 0; 
          }
        }
      });
  }
   
}
